import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/ui/alert-dialog";

/**
 * Confirms a site sync that includes Fobs (flag 8) before it's posted. Closing or Cancel posts
 * nothing; only "Sync fobs" calls `onConfirm`.
 */
export default function FobSyncConfirmDialog({
  open,
  siteName,
  onClose,
  onConfirm,
}: {
  open: boolean;
  siteName: string;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Sync fobs to sister sites?</AlertDialogTitle>
          <AlertDialogDescription>
            This resyncs every fob on <strong>{siteName || "this site"}</strong> to its sister
            sites. It can take a while and runs in the background.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Sync fobs</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
